export const splitbutton = {
  root: {
    borderRadius: "{form.field.border.radius}",
    roundedBorderRadius: "2rem",
    raisedShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
  },
  extend: {
    ui: {
      button: {
        paddingRight: "calc({button.padding.x} / 2)",
      },
      dropdown: {
        width: "calc({button.icon.only.width} - {splitbutton.ui.button.padding.right})",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-splitbutton-button {
      padding-inline-end: ${dt("splitbutton.ui.button.padding.right")};
    }

    .p-splitbutton-dropdown {
      width: ${dt("splitbutton.ui.dropdown.width")};
    }
  `,
};
